import type { ReactNode } from 'react';

/**
 * The header bar itself: the 52px band, its border, and the split between the
 * navigation on the left and the actions on the right. What goes in either side
 * is the area's composition to decide.
 */
export function AppHeaderRoot({
  left,
  right,
}: {
  left: ReactNode;
  right: ReactNode;
}) {
  return (
    <header className='col-start-2 flex items-center justify-between px-3 sm:px-4 sm:pr-5 border-b bg-header z-30 h-13'>
      <div className='flex items-center gap-1 min-w-0'>{left}</div>
      <div className='flex items-center gap-1.5 shrink-0'>{right}</div>
    </header>
  );
}
